import _ from 'lodash';

import {
  queryAreaWebsiteList, queryAreaWebsiteSign, queryResplyList,
  querySysLangOptions,
  querySysLanguage,
} from '../../_db/api.service';

import {
  CMS_TOKEN, FULL_DASHBOARD, FULL_PROFILE, GLOBAL_CATALOGS, GLOBAL_KEY,
  HAS_DETAILS,
  SET_USER_INFORMATION,
  SET_USER_LANGUAGE,
  USER_LANGUAGE_OPTIONS, WEBSITE_CODE, WEBSITE_ID,
  SET_WEBSITE_LIST,
  SET_WEBSITE_NAVIGATIONS,
  WEBSITE_SELECTED,
  USER_AREA_LANGUAGES_OPTIONS,
} from '../types';

import { getStorage, setStorage } from '../../utils/storage';

import {
  signCms,
  loginCms,
  queryCatalogsContentList,
} from '../../_db/cms.service';

import { queryAboutMenus } from './aboutAction';
import { queryNotificationMenus } from './bulletinsAction';
import { queryFaqsMenus } from './faqsActions';
import { queryDocumentsMenus } from './documentsActions';
import { queryContactMenus } from './contactActions';
import { querySignOffMenus } from './signatureActions';

import { removeNodeByCodeReduce, treeToList } from '../../utils/utils';

import { queryServiceFactory } from './shareActions';

import { queryAllContentList, queryCatalogList, queryCatalogsEventTracking, queryContentList, queryContentRecords } from './cmsAction';
import { queryLauanSafetyManagementList } from './service/laborActions';





// 獲取多語言數據
export function searchSysLanguages(langCode = 'zh_CN') {
  return (dispatch, getState) => {

    // const { account = {}, todo = {} } = getState();
    // langCode: 'zh_CN'

    return querySysLanguage({
      langCode
      // eslint-disable-next-line consistent-return
    }).then((res) => {
      const { success, result } = res || {};

      if (success) {
        dispatch(searchLanguageOptions());
        dispatch({
          type: SET_USER_LANGUAGE,
          payload: result
        });
        return result;
      }
    });
  };

};


// 獲取多語言數據字典
export function searchLanguageDictionary() {
  return async (dispatch, getState) => {
    const { success, result } = (await querySysLangOptions({ dictCode: 'system_language_template' })) || {};
    return { success, result };
  };
};


// 獲取多語言下拉選單
export function searchLanguageOptions() {
  return async (dispatch, getState) => {
    const { account: { website } } = getState();
    const { areaLanguageCode } = website?.selected || getStorage(WEBSITE_SELECTED) || {};
    const { success, result, timestamp } = (await dispatch(searchLanguageDictionary())) || {};
    

    const dedup = (arr = []) => { 
      const target = {}; 
      /* eslint-disable no-console */
      /* eslint-disable no-restricted-syntax */
      for (const obj of arr) { 
        const { regionCode , regionName, areaCode } = obj; 
        if (target[regionCode]) { 
          target[regionCode].items.push(obj);
        } else { 
          target[regionCode] = { regionCode, regionName, items: [obj] };
        } 
      } 
      return Object.values(target) 
    };

    const mergedArray = Object.values(
      _.reduce(_.map(website?.list, site => {
        const items = site?.areaLanguageCode?.split(',') || [];
        return {
          ...site,
          areaLanguageOptions: _.filter(result, option => items.includes(option?.langKey) )
        }
      }), (acc, item) => {
        const { regionCode, regionName } = item;
        if (!acc[regionCode]) {
          acc[regionCode] = { regionCode, regionName, items: [] };
        }
        acc[regionCode].items.push(item);
        return acc;
      }, {})
     );

    if(success) {
      const items = areaLanguageCode?.split(',') || [];
      dispatch({
        type: USER_LANGUAGE_OPTIONS,
        // payload: result?.filter(item => items.includes(item?.langKey) )
        payload: result
      });

      dispatch({
        type: USER_AREA_LANGUAGES_OPTIONS,
        payload: mergedArray
      });
    }
  };

};



// 全部站點
export const queryWebsiteList = () => async (dispatch, getState) => {
  const website_code = getStorage(WEBSITE_CODE);

  const { success, result } = await queryAreaWebsiteList() || {};

  if (success) {

    const current = result?.find((option) => option?.areaCode === website_code);

    const [initial, ...known] = result || [];

    await dispatch({
      type: SET_WEBSITE_LIST,
      payload: result
    });

    await dispatch(onChangeWebsiteItem(website_code ? current : initial));

  }

};



// 權限站點
export const queryPermissionWebsiteList = (area = {}, areas = []) => async (dispatch, getState) => {

  const website_code = getStorage(WEBSITE_CODE);

  const current = areas?.find((option) => option?.areaCode === website_code);

  const initial = areas?.find((option) => option?.areaCode === area?.areaCode);

  await dispatch({
    type: SET_WEBSITE_LIST,
    payload: areas
  });

  // 默認站點初始化
  await dispatch(onChangeWebsiteItem(website_code ? current : initial));

};



// 切換站點
export const onChangeWebsiteItem = (record) => async (dispatch, getState) => {

  const { areaCode, cmsSiteId, id } = record || {};

  // 獲取站點SIGN
  const { success, result } = (await queryAreaWebsiteSign({ areaCode })) || {};

  // 登錄CMS
  const { code, data } = (await loginCms({ siteId: cmsSiteId, sign: result })) || {};

  // 總務所需站點ID與CODE
  setStorage(WEBSITE_CODE, areaCode);
  setStorage(WEBSITE_ID, id);

  window.sessionStorage.setItem(WEBSITE_CODE, areaCode);
  window.sessionStorage.setItem(WEBSITE_ID, id);

  if(code && code === 200) { 
    setStorage(CMS_TOKEN, data?.token)
  };


  setStorage(WEBSITE_SELECTED, record);

  // 設置當前站點數據
  await dispatch({
    type: WEBSITE_SELECTED,
    payload: record
  });
  
  await dispatch(searchLanguageOptions());

  await dispatch(queryGlobalCatalogs());
  
};


// 用戶信息
export function setUserInformation({ profile, worker, today_visitor_number, total_readers_number }) {

  return async (dispatch, getState) => {
    const { account = {}, todo = {} } = getState();

    dispatch({
      type: SET_USER_INFORMATION,
      payload: {
        profile,
        worker,
        today_visitor_number,
        total_readers_number
      }
    });
  };
};



// 欄目Trees數據分解
export const queryGlobalCatalogs = () => async (dispatch, getState) => {

    // 全域-查詢廠區
    await dispatch(queryServiceFactory());

    // 查詢欄目Trees
    const { code, data } = (await dispatch(queryCatalogList())) || {};

    const length = data?.length;

    if(Boolean(code) && code === 200) {

      const setCatalogsMap = new Map([
        /* ******** Navigations ********************************************************************************************************* */
        [
          GLOBAL_CATALOGS.Navigations,
          (list) => {
            

            // Dispatch Header Navigations
            dispatch({
              type: SET_WEBSITE_NAVIGATIONS,
              payload: removeNodeByCodeReduce(removeNodeByCodeReduce(list, GLOBAL_CATALOGS.Coworking.News.List), GLOBAL_CATALOGS.Home) || []
            });

            // Dispatch Service sector
            const records = removeNodeByCodeReduce(_.find(list, item => [GLOBAL_CATALOGS.Service.Root].includes(item?.contentCode))?.children, GLOBAL_CATALOGS.Coworking.News.List);
            let original = {};

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < records?.length; i++) {
              // eslint-disable-next-line no-prototype-builtins
              if(!original?.hasOwnProperty(list[i]?.contentCode)) {
                original = { ...original, [records[i]?.contentCode]: records[i] }
              }
            };
            dispatch({
              type: GLOBAL_CATALOGS.Service.Root,
              payload: {
                tickets: original,
                list: records
              }
            });

            // 首頁最新消息初始化
            dispatch(queryLastNewsCategorys());

            // Dispatch 欄目MENUS
            dispatch(queryContentMenus(list))

          }
        ],

        /* ******** Dispatch 簽核中心 *************************************************************************************************** */
        [
          GLOBAL_CATALOGS.SignOff.Root,
          (list) => {
            dispatch(querySignOffMenus(list));
          }
        ],

        /* ******** Dispatch 勞工安全衛生管理處 ****************************************************************************************** */
        [
          GLOBAL_CATALOGS.Lauan.Root,
          (list) => {
            dispatch(queryLauanSafetyManagementList(list));
          }
        ],

        /* ******** Dispatch 頁腳服務 ******************************************************************************************************** */
        [

          GLOBAL_CATALOGS.FooterLink,
          (list) => {
            dispatch({
              type: GLOBAL_CATALOGS.FooterLink,
              payload: list
            });
          }
        ],

      ]);


      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < length; i++) {
        setCatalogsMap.get(data[i]?.contentCode)?.call(this, data[i]?.children);
      }

 

      /* ******** Dispatch Global ******************************************************************************************************** */
      dispatch({
        type: GLOBAL_KEY,
        payload: {
          trees: data,
          list: treeToList(JSON.parse(JSON.stringify(data)))
        }
      });

      /* ******** Dispatch 服務應用 **************************************************************************************************** */
      dispatch(queryApplicationList());
    };

}



// 欄目查询MENUS
export const queryContentMenus = (navigations = []) => async (dispatch, getState) => {

  const length = navigations?.length;

  const setCatalogsMap = new Map([

    // 關於我們欄目MENUS
    [
      GLOBAL_CATALOGS.About.Root,
      (list) => {
        dispatch(queryAboutMenus(list?.children));
      }
    ],

    // 消息中心欄目MENUS
    [
      GLOBAL_CATALOGS.Bulletins.Root,
      (list) => {
        dispatch(queryNotificationMenus(list?.children));
      }
    ],

    // 常見問題欄目MENUS
    [
      GLOBAL_CATALOGS.Faqs.Root,
      (list) => {
        dispatch(queryFaqsMenus(list?.children));
      }
    ],

    // 檔案下載欄目MENUS
    [
      GLOBAL_CATALOGS.Documents.Root,
      (list) => {
        dispatch(queryDocumentsMenus(list?.children));
      }
    ],

    // 聯繫我們欄目MENUS
    [
      GLOBAL_CATALOGS.Contact.Root,
      (list) => {
        dispatch(queryContactMenus(list?.children));
      }
    ],

    // 簽核中心欄目MENUS
    [
      GLOBAL_CATALOGS.SignOff.Root,
      (list) => {
        dispatch(querySignOffMenus(list?.children));
      }
    ],

  ]);



  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
    setCatalogsMap.get(navigations[i]?.contentCode)?.call(this, navigations[i]);
  }
};


/* ********************************************************************************************************* */
/* ********************************************************************************************************* */
/* ********************************************************************************************************* */

// 未登錄獲取首頁數據
export const getCmsData = () => async (dispatch, getState) => {
  const { code, data } = (await signCms({})) || {};
  const { siteId, token } = data || {};
  // i18n?.loadLanguages();
  if(code && code === 200){
      await setStorage(CMS_TOKEN, token);
      await dispatch(queryUnTokenDashboardData({ siteId, token }))
  };
};

// 首頁-獲取未登錄展示數據
export const queryUnTokenDashboardData = ({ siteId, token }) => async (dispatch, getState) => {
  const { code: success1, data: banner } = await queryCatalogsContentList({ siteId, contentCode: GLOBAL_CATALOGS.Banner, hasDetails: false, pageNum: 1, pageSize: 10 }) || {};
  const { code: success2, data: application } = await queryCatalogsContentList({ siteId, contentCode: GLOBAL_CATALOGS.ServiceApplication, hasDetails: false, pageNum: 1, pageSize: 10 }) || {};
  dispatch({
    type: GLOBAL_CATALOGS.Banner,
    payload: banner?.records
  });
  dispatch({
    type: GLOBAL_CATALOGS.ServiceApplication,
    payload: application?.records
  });
};

/* ********************************************************************************************************* */


// 首頁-Banner
export const queryDashboardBanner = (params) => async (dispatch, getState) => {
  const { list } = await dispatch(queryContentRecords({ contentCode: GLOBAL_CATALOGS.Banner, hasDetails: HAS_DETAILS.True }));
  dispatch({
    type: GLOBAL_CATALOGS.Banner,
    payload: list
  });
};

// 首頁-為你推薦
export const queryRecommend = () => async (dispatch, getState) => {
  const { list } = await dispatch(queryCatalogsEventTracking());
  dispatch({
    type: GLOBAL_CATALOGS.Recommend,
    payload: list
  })
};


// 首頁-最新消息-TABS類別
export const queryLastNewsCategorys = (params) => async (dispatch, getState) => {
  const { account: { serviceSector }  } = getState();
  dispatch({
    type: FULL_DASHBOARD.News.Tabs,
    payload: [
      { label: '最新', contentCode: GLOBAL_CATALOGS.Bulletins.LatestNews.List },
      ...serviceSector?.list
    ]
  });
  dispatch(changeLastNewsTabItem(GLOBAL_CATALOGS.Bulletins.LatestNews.List));
};
// 首頁-最新消息-選擇最TABS ITEM
export const changeLastNewsTabItem = (value) => async (dispatch, getState) => {
  const { list } = await dispatch(queryAllContentList({ contentCode: value, page: 1, rowsPerPage: 3 }));
  dispatch({
    type: FULL_DASHBOARD.News.Value,
    payload: value
  });
  dispatch({
    type: FULL_DASHBOARD.News.List,
    payload: list
  });
};


// 首頁-友善連結
export const queryFriendlyLinks = (params) => async (dispatch, getState) => {
  const { list } = await dispatch(queryContentRecords({ contentCode: GLOBAL_CATALOGS.Link }));
  dispatch({
    type: GLOBAL_CATALOGS.Link,
    payload: list
  })
};


/* ********************************************************************************************************* */
/* ********************************************************************************************************* */

// 服務應用
export const queryApplicationList = (params) => async (dispatch, getState) => {
  const { list } = await dispatch(queryContentRecords({ contentCode: GLOBAL_CATALOGS.ServiceApplication }));
  dispatch({
    type: GLOBAL_CATALOGS.ServiceApplication,
    payload: list
  });
};


/* ********************************************************************************************************* */
/* ********************************************************************************************************* */


// 個人資料-我的回應
export const queryUserReplyList = (params) => async (dispatch, getState) => {
  const { page, rowsPerPage, messageType } = params || {};
  const { success, result } = await queryResplyList({ pageNo: page, pageSize: rowsPerPage, messageType });
  const { records, current, pages, size, total } = result || {};

  dispatch({
    type: FULL_PROFILE.Reply.List,
    payload: {
      list: records,
      total,
      page: current,
      rowsPerPage: size,
      pages,
      isLoading: false
    }
  })
};



// 個人資料-我的報修
export const queryUserRepairList = (params) => async (dispatch, getState) => {
  const { page, rowsPerPage, messageType } = params || {};
  const { success, result } = await queryResplyList({ pageNo: page, pageSize: rowsPerPage, messageType });
  const { records, current, pages, size, total } = result || {};

  dispatch({
    type: FULL_PROFILE.Repair.List,
    payload: {
      list: records,
      total,
      page: current,
      rowsPerPage: size,
      pages,
      isLoading: false
    }
  })

};